import React from "react";

const FormError = (props) => {
  if (!props.error) return null;
  // A message with several lines (one problem per line) gets a paragraph each.
  const lines = String(props.error).split("\n");
  return (
    <div className="FormError">
      {lines.map((line, i) => <p key={i}>{line}</p>)}
    </div>
  )
}

export default FormError;